module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DeviceConnection"
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(" Device Connection ")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('md-input-container', {
    staticClass: "fixed-width-container"
  }, [_c('label', [_vm._v(" serialport-bridge host address")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.serialBridgeAddress
    },
    on: {
      "change": _vm.onSerialBridgeAddressChange
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('md-switch', {
    staticClass: "md-primary",
    attrs: {
      "disabled": _vm.serialPortOpen
    },
    on: {
      "change": _vm.onSerialBridgeConnectChange
    }
  }, [_vm._v(" \n        connect to serialport-bridge\n      ")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('md-input-container', {
    staticClass: "fixed-width-container"
  }, [_c('label', [_vm._v(" serial port ")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "disabled": _vm.serialPortSelectDisabled,
      "value": _vm.serialPortName
    },
    on: {
      "change": _vm.onPortSelectChange
    }
  }, _vm._l((_vm.serialPortArray), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item.device
      }
    }, [_vm._v(" \n            " + _vm._s(item.device) + " (" + _vm._s(item.product) + ")\n          ")])
  }))], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('md-switch', {
    staticClass: "md-primary",
    attrs: {
      "value": _vm.serialPortOpen,
      "disabled": _vm.serialPortSwitchDisabled
    },
    on: {
      "change": _vm.onSerialPortOpenChange
    }
  }, [_vm._v(" \n        open serial port\n      ")])], 1), _vm._v(" "), (_vm.showDeviceInfo) ? _c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('md-table', [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', [_vm._v(" Device Information ")]), _vm._v(" "), _c('md-table-head')], 1)], 1), _vm._v(" "), _c('md-table-body', [_c('md-table-row', [_c('md-table-cell', [_vm._v(" Firmware Version ")]), _vm._v(" "), _c('md-table-cell', [_vm._v(" " + _vm._s(_vm.deviceFirmwareVersion) + " ")])], 1), _vm._v(" "), _c('md-table-row', [_c('md-table-cell', [_vm._v(" Hardware Variant ")]), _vm._v(" "), _c('md-table-cell', [_vm._v(" " + _vm._s(_vm.deviceHardwareVariant) + " ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": ""
    }
  }, [(_vm.showDebugButton) ? _c('md-button', {
    staticClass: "md-primary md-raised",
    on: {
      "click": _vm.onDebugClick
    }
  }, [_vm._v(" \n        Debug \n      ")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-987a33d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeviceConnection.vue
// module id = 166
// module chunks = 1